import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface RevenueChartProps {
  data: any[];
}

export function RevenueChart({ data }: RevenueChartProps) {
  const displayData = data && data.length > 0 ? data : generateDemoRevenueData();

  return (
    <div
      className="rounded-2xl p-6 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-6">
        <h3 style={{ color: '#f5f5f7' }} className="text-lg font-semibold">
          Receita Diária
        </h3>
        <p style={{ color: '#8a8a95' }} className="text-sm">
          Últimos 30 dias
        </p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={displayData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(138, 138, 149, 0.1)" />
          <XAxis
            dataKey="date"
            stroke="#75757f"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke="#75757f"
            style={{ fontSize: '12px' }}
            label={{ value: 'R$', angle: -90, position: 'insideLeft' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#131318',
              border: '1px solid #1e1e25',
              borderRadius: '8px',
              color: '#f5f5f7',
            }}
            formatter={(value: number) => `R$ ${value.toFixed(2)}`}
            cursor={{ fill: 'rgba(180, 163, 255, 0.1)' }}
          />
          <Legend wrapperStyle={{ color: '#75757f' }} />
          <Bar
            dataKey="receita"
            fill="#08d660"
            name="Receita"
            radius={[4, 4, 0, 0]}
            isAnimationActive={true}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

function generateDemoRevenueData() {
  const data = [];
  for (let i = 29; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    data.push({
      date: date.toLocaleDateString('pt-BR', { month: 'short', day: 'numeric' }),
      receita: Math.floor(1000 + Math.random() * 3000),
    });
  }
  return data;
}
